import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import resourcesToBackend from "i18next-resources-to-backend"
import ChainedBackend from "i18next-chained-backend"

import {
  format as formatDate,
  formatDistance,
  formatRelative,
  isDate,
} from "date-fns"
import { enUS, fr } from "date-fns/locale" // import all locales we need

const locales: any = { en: enUS, fr }
// import LocalStorageBackend from "i18next-localstorage-backend"

export default function initI18n() {
  i18n
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .use({
      type: "postProcessor",
      name: "lettersCase",
      process: function (value: string, key: any, options: any) {
        const lettersCase = options.lettersCase ?? "capitalize"
        switch (lettersCase) {
          case "lowercase":
            return value.toLowerCase()
          case "uppercase":
            return value.toUpperCase()
          case "capitalize":
            return `${value.charAt(0).toUpperCase()}${value
              .slice(1)
              .toLowerCase()}`
          case "capitalizeFirst":
            return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
          case "none":
            return value
          default:
            return "No case matched"
        }
      },
    })

    .init({
      nonExplicitSupportedLngs: true,
      load: "languageOnly",
      supportedLngs: ["en", "fr"],
      lng: localStorage.getItem("i18nextLng") || "fr",
      fallbackLng: "fr",
      fallbackNS: "translation",
      returnObjects: true,
      postProcess: "lettersCase",

      backend: {
        // TODO caching
        backends: [
          // ...(process.env.NODE_ENV !== "development"
          //   ? [LocalStorageBackend]
          //   : []),
          resourcesToBackend((language, namespace, callback) => {
            import(`../locales/${language}/${namespace}.json`)
              .then((resources) => {
                callback(null, resources)
              })
              .catch((error) => {
                callback(error, null)
              })
          }),
        ],
        backendOptions: [
          {
            versions: { en: "0.1.0-rc.1", fr: "0.1.0-rc.1" },
          },
        ],
      },
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        format: (value, format, lng) => {
          if (isDate(value)) {
            const locale = locales[lng!]

            if (format === "short") return formatDate(value, "P", { locale })
            if (format === "long") return formatDate(value, "PPPP", { locale })
            if (format === "relative")
              return formatRelative(value, new Date(), { locale })
            if (format === "ago")
              return formatDistance(value, new Date(), {
                locale,
                addSuffix: true,
              })
            return formatDate(value, format!, { locale })
          }
          return value
        },
      },
    })
}
